// extracted by mini-css-extract-plugin
export var frame = "frame-module--frame--3K81u";